<style lang="stylus">
  .logout-success
    color green
  .logout-error
    color red
</style>

<template lang="jade">
  div#login-container
    div.logout-success(v-if="successmessage")
      p {{ successmessage }}
    div.logout-error(v-if="errormessage")
      p {{ errormessage }}
    div.form-group
      button.btn.btn-danger.form-control(
        v-if="!proccessing"
        @click.prevent="logout"
      ) {{ buttonText }}
      div.sk-cube-grid(v-else)
        - for (var x = 0; x < 9; x++)
            div.sk-cube.sk-cube-piece
</template>

<script>
  // import { config } from '../vuex/getters'

  export default {
    data () {
      return {
        proccessing: false,
        errormessage: '',
        successmessage: '',
        buttonText: this.trans('logout.buttonText')
      }
    },
    // vuex: {
    //   getters: {
    //     config
    //   }
    // },
    methods: {
      logout () {
        this.proccessing = true
        this.$http.post(this.config.http.root + this.config.endpoints.logout)
        .then(response => {
          if (response.data.success === true) {
            this.successmessage = this.trans('logout.success')
          } else {
            this.errormessage = this.trans('logout.failed', response.data.failureMessage)
          }
          this.proccessing = false
        }, response => {
          this.errormessage = this.trans('logout.error')
          this.proccessing = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Logout.vue?3ac5081e